<template>
  <div class="page_pays">
    <h1>Platby</h1>
    <div class="actions">
      <button class="add" @click="add" title="Nová platba">
        <i class="fa fa-plus"></i>
      </button>
      <button class="sync" @click="sync" title="Načíst platby z banky">
        <i class="fas fa-sync-alt"></i>
      </button>
    </div>
    <tabloid name="page_pays" :columns="columns" :data="payments">
      <template v-slot:outpostId="{ row }">
        <inputerSelect :paths="['payments', row.id, 'outpostId']" :items="outposts" :getKey="item => item.id">
          <template v-slot:default="props">{{ props.id != null ? `${props.id}. PH` : "Vyberte" }}</template>
          <template v-slot:item="props">{{ props.id }}. PH - {{ props.item.city }}</template>
        </inputerSelect>
      </template>
      <template v-slot:date="{ row }">
        <inputerDate name :paths="['payments', row.id, 'date']" :time="true" />
      </template>
      <template v-slot:message="{ row }">
        <inputer name="Poznámka" :paths="['payments', row.id, 'message']" />
      </template>
      <template v-slot:amount="{ row }">
        <inputerNumber name="Částka" :paths="['payments', row.id, 'amount']" />
      </template>
      <template v-slot:actions="{ row }">
        <button @click="remove(row.id)" class="remove">
          <i class="fa fa-times"></i>
        </button>
      </template>
    </tabloid>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { data } from "../../store_utils";
import tabloid from "../../components/tabloid.vue";
import inputer from "../../components/inputer";
import inputerNumber from "../../components/inputer-number";
import inputerSelect from "../../components/inputer-select";
import inputerDate from "../../components/inputer-date";

export default {
  name: "pays",
  components: {
    tabloid,
    inputer,
    inputerNumber,
    inputerSelect,
    inputerDate
  },
  data: () => ({
    columns: {
      outpostId: { title: "Hlídka" },
      date: { title: "Čas" },
      message: { title: "Poznámka" },
      amount: { title: "Částka" },
      actions: { title: " " },
    },
  }),
  computed: {
    ...mapState(["outposts", "payments"]),
  },
  methods: {
    add() {
      const newGuid = data.newGuid();
      this.$store.commit("add", {
        paths: ["payments", newGuid],
        value: {
          id: newGuid,
          outpostId: null,
          amount: 0,
          date: new Date(),
          message: ""
        }
      });
    },
    remove(id) {
      if (!confirm("Opravdu chcete odstranit tuto položku?")) return;

      this.$store.commit("remove", {
        paths: ["payments", id]
      });
    },
    sync() {
      this.$store.dispatch("syncPayments");
    }
  },
};
</script>

<style lang="sass">
@import ../../sass/_components

.page_pays
  @include table-view()
  grid-template-areas: "label action" "table table"
  grid-template-columns: auto 1fr
  grid-column-gap: 1rem
  h1
    grid-area: label
  .actions
    grid-area: action
    .add
      @include first-input()
    .sync
      @include button-secondary()
      @include last-input()
  table
    grid-area: table
    .remove
      @include button-danger()
</style>